<template>
  <el-row type="flex" justify="start" align="middle" class="tg-date-search">
    <template v-if="showDateRangePicker">
      <tg-date-range-selector
        ref="selector"
        v-bind="datePickerOptions"
        :isAccountDate="isAccountDate"
        @on-change="handleRadioDate"
      ></tg-date-range-selector>
    </template>
    <el-row type="flex" justify="start">
      <tg-date-picker
        v-model="dateRange.startDate"
        :options="datePickerOptions"
        :show-time="showTime"
      ></tg-date-picker>
      <span>-</span>
      <tg-date-picker
        v-model="dateRange.endDate"
        :options="datePickerOptions"
        :show-time="showTime"
      ></tg-date-picker>
    </el-row>
  </el-row>
</template>

<script>
import TgDateRangeSelector from "@/components/datePicker/TgDateRangeSelector";
import TgDatePicker from "@/components/datePicker/TgDatePicker";
import date from "@/utils/date";

import { makeDateRangeProps, showDates } from "./mixins";

export default {
  components: {
    TgDatePicker,
    TgDateRangeSelector,
  },
  data() {
    return {
      dateRange: {
        startDate: "",
        endDate: "",
      },
    };
  },
  props: {
    ...makeDateRangeProps(),
    value: [Object, String],
    showDateRangePicker: Boolean,
    twoMonthLimit: Boolean,
    oneYearLimit: Boolean,
    isAccountDate: Boolean,
    mini: Boolean,
    // RM20260715103 時分篩選：opt-in 開啟時分選擇
    showTime: Boolean,
  },
  created() {
    if (this.value) {
      this.dateRange = this.withDefaultTime(this.value);
    }
  },
  mounted() {
    this.$emit("input", this.dateRange);

    this.select("today");

    // showTime 且無快捷選日列時，初始值會是「現在時刻」，改為今日 00:00 ~ 23:59（維持原整日語意）
    if (this.showTime && !this.showDateRangePicker) {
      const datePart = (v) => (typeof v === "string" ? v.split(" ")[0] : v);
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.dateRange = {
          startDate: `${datePart(this.dateRange.startDate)} 00:00`,
          endDate: `${datePart(this.dateRange.endDate)} 23:59`,
        };
      }
    }
  },
  computed: {
    datePickerOptions() {
      let options = showDates.reduce((prev, ctr) => {
        prev[ctr] = this.$props[ctr];
        return prev;
      }, {});

      if (this.twoMonthLimit) {
        options.minDate = date.diffMonth(-2);
        options.maxDate = date.tomorrow();
      } else if (this.oneYearLimit) {
        options.minDate = date.diffYear(-1);
        options.maxDate = date.tomorrow();
      }

      return options;
    },
  },
  methods: {
    handleRadioDate(dateRange) {
      this.dateRange = this.withDefaultTime(JSON.parse(JSON.stringify(dateRange)));
    },
    // showTime 模式下，純日期值補預設時分：起 00:00、迄 23:59（等同整日，對齊管理後台）
    withDefaultTime(range) {
      if (!this.showTime || !range || typeof range !== "object") {
        return range;
      }
      const hasTime = (v) => typeof v === "string" && /\d{1,2}:\d{2}/.test(v);
      if (range.startDate && !hasTime(range.startDate)) {
        range.startDate = `${range.startDate} 00:00`;
      }
      if (range.endDate && !hasTime(range.endDate)) {
        range.endDate = `${range.endDate} 23:59`;
      }
      return range;
    },
    select(name) {
      if (this.showDateRangePicker) {
        this.$refs.selector.select(name);
      }
    },
  },
  watch: {
    dateRange(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.dateRange = this.withDefaultTime(val);
    },
  },
};
</script>
